<template>
  <div class="zoom-phone-toggle-button-wrapper">
    <BTooltip
      top
      :content="zoomPhoneWidgetVisible ? $t('vaApp.zoomPhone.hideWidget') : $t('vaApp.zoomPhone.showWidget')"
    >
      <BBtn
        type="primary"
        fab
        class="zoom-phone-toggle-button"
        @click="toggleWidget"
      >
        <template v-if="zoomPhoneWidgetVisible">
          <BCustomIcon
            icon-class="b-arrow-down"
          />
        </template>
        <template v-else>
          <BIcon>
            call
          </BIcon>
        </template>
      </BBtn>
    </BTooltip>
  </div>
</template>

<script setup lang="ts">
import { inject, onMounted, onUnmounted } from 'vue';
import { ZOOM_PHONE_WIDGET_VISIBLE_KEY } from '@/composable/va-app/zoom-phone-widget/zoom-phone-widget-visible';

const zoomPhoneWidgetVisible = inject(ZOOM_PHONE_WIDGET_VISIBLE_KEY);
if (!zoomPhoneWidgetVisible) {
  throw new Error('ZoomPhoneToggleButton: ZOOM_PHONE_WIDGET_VISIBLE_KEY is not provided');
}

const toggleWidget = () => {
  if (zoomPhoneWidgetVisible.value) {
    zoomPhoneWidgetVisible.value = false;
    return;
  }

  zoomPhoneWidgetVisible.value = true;
};

const handleGlobalKeydown = (e: KeyboardEvent) => {
  // Mac: Command+Shift+L / Windows: Control+Shift+L
  if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'l') {
    e.preventDefault();
    toggleWidget();
  }
};

onMounted(() => {
  document.addEventListener('keydown', handleGlobalKeydown);
});

onUnmounted(() => {
  document.removeEventListener('keydown', handleGlobalKeydown);
});
</script>

<style lang="scss" scoped>
// 詳細度をより高くして BBtn の fab スタイルを上書きしてサイズを指定
.zoom-phone-toggle-button-wrapper .zoom-phone-toggle-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  box-shadow: $boxshadow-base;

  width: 56px;
  height: 56px;
  min-width: 56px;
  min-height: 56px;

  // NOTE: 文字起こし画面のローディングのz-index 2000に合わせる
  z-index: 2000;

  :deep(.inner .b-icon) {
    font-size: 28px;
  }
}
</style>
